<div class="flex gap-x-2">
  <input
    [id]="controlName"
    [formControl]="control"
    type="checkbox"
    class="form-checkbox size-5 rounded border border-grey-midGrey"
    role="checkbox"
    (keydown)="handleKeyDown($event)"
  />
  <div class="flex-1">
    <span class="break-words text-sm text-grey">
      <ng-container *ngTemplateOutlet="label"></ng-container>
    </span>
  </div>
</div>
